import React from 'react'

const InputShadowTwo = ({ name, value, placeholder, onChange, image, onClick }) => {
    return (
        <div className='mt-3'> 
            <div className="input-group rounded-pill shadow">
                <span 
                    className="bg-white border-0 rounded-pill" 
                    style={{ marginLeft:'1rem', paddingTop:'0.1rem'}}
                >
                    <img src={image} alt='image du logo' style={{ height:20, width:20, marginTop:'0.2rem' }} />
                </span>
                <input type="text" className='form-control border-0' value={value} name={name} onChange={onChange} placeholder={placeholder} />
                <span 
                    className="bg-white border-0 rounded-pill" 
                    style={{ marginRight:'0.5rem', paddingTop:'0.2rem', height:20, width:20 }}
                >
                    <div className='fw-bold' style={{ color: 'lightgray', marginTop:'0.3rem' }} onClick={onClick}>X</div>
                </span>
            </div>
        </div>
    )
}

export default InputShadowTwo